import React from 'react';
import RightTerrase from './Components/RightTerrase';
import SecondApartament from './Components/SecondApartament';
import ThirdApartament from './Components/ThirdApartament';
import FourthApartament from './Components/FourthApartament';
import FifthApartament from './Components/FifthApartament';
import SixthApartament from './Components/SixthApartament';
import SeventhApartament from './Components/SeventhApartament';
import EighthApartament from './Components/EighthApartament';
import NinethApartament from './Components/NinethApartament';
import TenthApartament from './Components/TenthApartament';

function Floor1() {

  return (
    <div className='w-[100vw] relative mt-40 mb-40 lg:h-auto'>
      <div className="w-[100vw] relative ">
        <img
          className='w-full'
          src="/images/click/clickable-images/Floors/Direct-floors/clean-floors/Floor1K5K6.jpg"
          alt=""
        />
        <>
          <RightTerrase />
          <SecondApartament />
          <ThirdApartament />
          <FourthApartament />
          <FifthApartament />
          <SixthApartament />
          <SeventhApartament />
          <EighthApartament />
          <NinethApartament />
          <TenthApartament />
        </>
      </div>
    </div>
  );
}

export default Floor1;
